import type { RevisaoFornecedorStepProps } from "./types-revisao-fornecedor-step";
import { useRevisaoFornecedorStep } from "./use-revisao-fornecedor-step";
import { RevisaoFornecedorStepView } from "./view-revisao-fornecedor-step";

export function RevisaoFornecedorStep(props: RevisaoFornecedorStepProps) {
  const vm = useRevisaoFornecedorStep(props);

  return <RevisaoFornecedorStepView {...vm} />;
}

export type * from "./types-revisao-fornecedor-step";
